<img *ngIf="showImage" [src]="src" [alt]="alt" (error)="onError()">

<iconify-icon *ngIf="!showImage" [attr.icon]="icon" [attr.width]="iconSize"
  [attr.height]="iconSize"></iconify-icon>
